export interface BurnInJob {
  id: number;
  source_video_id: number;
  source_content_id: number;
  source_content_title: string;
  source_content_slug: string;
  source_video_file_name: string;
  source_season_id: number | null;
  source_series_id: number | null;
  subtitle_id: number;
  lang: string;
  status: BurnInJobStatus;
  batch_job_id: string;
  batch_group_id: string;
  error_message: string;
  result_video_id: number | null;
  result_content_id: number | null;
  result_season_id: number | null;
  result_series_id: number | null;
  created: string;
  modified: string;
}

export type BurnInJobStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface BurnInValidationResult {
  available: BurnInValidationItem[];
  skipped: BurnInSkippedItem[];
}

export interface BurnInValidationItem {
  content_id: number;
  title: string;
  slug: string;
  video_id: number;
  subtitle_id: number;
}

export interface BurnInSkippedItem {
  content_id: number;
  title: string;
  slug: string;
  reason: string;
}

export const BURNIN_STATUS_COLORS: Record<BurnInJobStatus, string> = {
  pending: 'default',
  processing: 'processing',
  completed: 'success',
  failed: 'error',
};
